import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { Container } from './Container';
import { ButtonLink } from './ButtonLink';
import { primaryNav, site } from '../data/site';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const prefersReducedMotion = useReducedMotion();
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 8);
    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);
  return <header className={`sticky top-0 z-50 transition-colors duration-200 ease-out ${isScrolled || isMenuOpen ? 'bg-canvas border-b border-hairline' : 'bg-transparent border-b border-transparent'}`} data-id="element-415" data-mp="3fb8bdyaryhot">
      <Container data-id="element-416" data-mp="2rkgdl9pia577">
        <div className="flex h-[72px] items-center justify-between" data-id="element-417" data-mp="2ro4a8hq8z7q5">
          <Link to="/" className="text-[16px] font-semibold tracking-normal text-ink" aria-label={`${site.name} — home`} data-id="element-418" data-mp="2mn6ro41bsbo4">
            {site.name}
          </Link>

          <nav aria-label="Primary" className="hidden items-center gap-9 md:flex" data-id="element-419" data-mp="3fakgfeuve0x5">
            {primaryNav.map(link => <NavLink key={link.to} to={link.to} className={({
            isActive
          }) => `text-small transition-colors duration-150 ease-out hover:text-ink ${isActive ? 'text-ink' : 'text-muted'}`} data-id="element-420" data-mp="35lj3xynja1nx">
                {link.label}
              </NavLink>)}
          </nav>

          <div className="flex items-center gap-3" data-id="element-421" data-mp="1rdtg87va4la6">
            <ButtonLink to="/contact" className="hidden sm:inline-flex" data-id="element-422" data-mp="1re36zxo5ewgx">
              Start a Project
            </ButtonLink>
            <button type="button" onClick={() => setIsMenuOpen(open => !open)} aria-expanded={isMenuOpen} aria-controls="mobile-nav" aria-label={isMenuOpen ? 'Close menu' : 'Open menu'} className="flex h-11 w-11 items-center justify-center rounded-card border border-hairline text-ink transition-colors duration-150 ease-out hover:border-ink md:hidden" data-id="element-423" data-mp="1weh44ko7om06">
              {isMenuOpen ? <XIcon size={18} data-id="element-424" data-mp="yqgufzwy0hhx" /> : <MenuIcon size={18} data-id="element-425" data-mp="yr0ebm65lfyl" />}
            </button>
          </div>
        </div>
      </Container>

      <AnimatePresence data-id="element-426" data-mp="13ptr1cdm92xp">
        {isMenuOpen && <motion.div id="mobile-nav" initial={prefersReducedMotion ? false : {
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={prefersReducedMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="border-t border-hairline bg-canvas md:hidden" data-id="element-427" data-mp="2t3yl3vsn9uh6">
            <Container data-id="element-428" data-mp="w5j334ovxzm6">
              <nav aria-label="Mobile" className="flex flex-col py-4" data-id="element-429" data-mp="w5ski3vv6yg9">
                {primaryNav.map(link => <NavLink key={link.to} to={link.to} className="border-b border-hairline py-4 text-[20px] tracking-[-0.02em] text-ink last:border-b-0" data-id="element-430" data-mp="rbwpnaawdrpb">
                    {link.label}
                  </NavLink>)}
                <ButtonLink to="/contact" className="mt-6 w-full sm:hidden" data-id="element-431" data-mp="1a491cnnfy5c4">
                  Start a Project
                </ButtonLink>
              </nav>
            </Container>
          </motion.div>}
      </AnimatePresence>
    </header>;
}